//Core
import React, { useState } from "react"

//Styles
import style from "./style.module.scss"

//Components
import Seo from "./Seo"
import Header from "./Header"
import Main from "./Main"
import Callback from "./Callback"
import Footer from "./Footer"

const Layout = ({ description, title, link, children, hideHeader = false }) => {
  const [showHeader, setShowHeader] = useState(!hideHeader)

  const closeHeader = () => setShowHeader(false)
  const openHeader = () => setShowHeader(true)

  return (
    <div className={style.Layout}>
      <Seo title={title} description={description} link={link}></Seo>
      <Header showHeader={showHeader}></Header>
      <Main
        openHeader={openHeader}
        hideHeader={hideHeader}
        closeHeader={closeHeader}
      >
        {children}
      </Main>
      <Callback></Callback>
      <Footer></Footer>
    </div>
  )
}

export default Layout
